// extracted by mini-css-extract-plugin
export default {"body":"Profile_body__dTG4U","content":"Profile_content__BquDU","menuGroup":"Profile_menuGroup__rdvUm"};